import React from 'react';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <p className="footer-text">
                    © {currentYear} Дарья Карпенко. Все права защищены.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
